import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface TransactionDetails {
    id: string;
    status: string;
    amount: string;
    currency: string;
    date: string;
    time: string;
    identifier: string;
    name: string;
    card: string;
    category: string;
}

@Component({
    selector: 'app-transaction-details-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './transaction-details-modal.html',
    styleUrls: ['./transaction-details-modal.scss']
})
export class TransactionDetailsModalComponent {
    @Input() transaction: TransactionDetails = {
        id: '',
        status: 'POSTED PENDING',
        amount: '80,050.75',
        currency: 'INR',
        date: '14 Jun',
        time: '5:35AM',
        identifier: '4366185103630385',
        name: 'ATM withdrawal',
        card: '**** 1234',
        category: 'Overall Budget'
    };

    getStatusClass(status: string): string {
        const statusMap: { [key: string]: string } = {
            'POSTED PENDING': 'status-pending',
            'SUCCESS': 'status-success',
            'FAILED': 'status-failed',
            'PROCESS': 'status-process'
        };
        return statusMap[status] || 'status-pending';
    }
}
